import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

export const getUsers = (params = '') => Http.get(`/users${serialize(params)}`)

export const getUserStatsDashboard = (params = '') => Http.get(`/users/stats/dashboard${serialize(params)}`)

export const anonymizeUser = (userId) => Http.delete(`/admin/users/${userId}/anonymize`)
